// extracted by mini-css-extract-plugin
module.exports = {"bottomfooter":"Footer_Dis_bottomfooter__0WpX9","Container":"Footer_Dis_Container__VM9f0"};